module.exports = __webpack_public_path__ + "img/safety-screen.b52f6e48.png";